<ngrx-busy>
  <form [formGroup]="form"
    (ngSubmit)="save()"
    class="side-form">

    <h3>Update promo code</h3>

    <mat-form-field appearance="fill">
      <mat-label>Code</mat-label>
      <input matInput
        formControlName="code">
      @if (form.get('code').hasError('required')) {
        <mat-error><strong>required</strong></mat-error>
      }
      @if (form.get('code').hasError('minlength')) {
        <mat-error><strong>Code should contain 6 characters</strong></mat-error>
      }
      @if (form.get('code').hasError('maxlength')) {
        <mat-error><strong>Only 32 characters allowed</strong></mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Trial days</mat-label>
      <input matInput
        formControlName="trial_days"
        required
        [imask]="{mask: Number, scale: 0}">
      @if (form.get('trial_days').hasError('required')) {
        <mat-error><strong>required</strong></mat-error>
      }
      @if (form.get('trial_days').hasError('min')) {
        <mat-error><strong>min value is 1</strong></mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Link to customer</mat-label>
      <input matInput
        formControlName="linked_to"
        [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete"
        [displayWith]="displayFn">
        @for (option of customers$ | async; track option) {
          <mat-option
            [value]="option">
            {{option.full_name}} ({{option.email}})
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Usage limit</mat-label>
      <input matInput
        formControlName="usage_limit"
        required
        [imask]="{mask: Number, scale: 0}">
      @if (form.get('usage_limit').hasError('required')) {
        <mat-error><strong>required</strong></mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>valid_until</mat-label>

      <mtx-datetimepicker #validUntil
        type="datetime"
        mode="portrait"
        startView="clock"
        [twelvehour]="false"
      [timeInput]="true"></mtx-datetimepicker>
      <input matInput
        [mtxDatetimepicker]="validUntil"
        formControlName="valid_until">
      <mtx-datetimepicker-toggle matSuffix
      [for]="validUntil"></mtx-datetimepicker-toggle>
      @if (form.get('valid_until').hasError('required')) {
        <mat-error><strong>required</strong></mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Note</mat-label>
      <textarea matInput
        rows="3"
        formControlName="note">
      </textarea>
    </mat-form-field>

    <mat-checkbox formControlName="active">Active</mat-checkbox>

    <div class="side-form-actions">
      <button mat-raised-button
        type="submit"
        color="primary"
        [disabled]="form.invalid">
        Update
      </button>
    </div>

    <app-form-error></app-form-error>
  </form>
</ngrx-busy>
